import classNames from "classnames";

type StaticTipProps = {
  headingText: string;
  /** Heading colour. Ignored when `variant` is `attention`. */
  titleColorOverride?: "black" | "cerise" | "navy";
  variant?: "general" | "attention";
  children: React.ReactNode;
};

/**
 * Callout box for a note or warning.
 *
 * `general` is grey; `attention` is pink and forces a cerise heading.
 */
export const StaticTip = ({
  headingText,
  titleColorOverride,
  variant = "general",
  children,
}: StaticTipProps) => {
  return (
    <div
      className={classNames("px-3 py-4", {
        "bg-[#E8E8EB]": variant === "general",
        "bg-[#FCEFF4]": variant === "attention",
      })}
    >
      <p
        className={classNames("mb-[10px] font-bold text-[16px]", {
          "text-cerise":
            variant === "attention" || titleColorOverride === "cerise",
          "text-black-rock": titleColorOverride === "black",
          "text-pro-blue": titleColorOverride === "navy",
        })}
      >
        {headingText}
      </p>
      <div className="text-mono-70">{children}</div>
    </div>
  );
};
